import { useRef, useMemo } from "react";
import DataTableWrapper from "../../Utility/DataTableWrapper/DataTableWrapper";
import moment from "moment";
import { EventoService } from "../../../services/EventoService";

export default function ArsAudit() {
    const eventoService = new EventoService();
    const dtRef = useRef();

    const dtOptions = useMemo(() => {
        return {
        columns: [
                {
                    name: "Id",
                    data: "id",
                    visible: true,
                    sortable: false,
                    searchable: false,
                },
                {
                    name: "Azione",
                    data: "azione",
                    visible: true,
                    sortable: false,
                    searchable: true
                },
                {
                    name: "C.F Utente",
                    data: "createdBy",
                    visible: true,
                    sortable: true,
                    searchable: true
                },
                {
                    name: "Data evento",
                    data: "createdAt",
                    visible: true,
                    sortable: true,
                    searchable: true,
                    cell: (row, col) => {
                        return moment(row.createdAt).format("DD/MM/YYYY HH:mm:ss");
                    }
                }/* ,
                {
                    name: "Esito",
                    data: "",
                    visible: true,
                    sortable: false,
                    searchable: true,
                    cell: (row, col) => {
                        return row.azione === "SALVATAGGIO_EMAIL"? "OK" : "KO";
                    }
                } */
            ],
            serverSide: true,
            rows: [],
            sorts: [{name:'createdAt',direction:'desc'}],
            hideSearch: false,
            title: "Elenco eventi Controllo ARS",
            ajax: eventoService.getAllDt,
            ajaxParams: {
                entity: ["ControlloArs"]
            },
        };
    }, []);

    return (
        <DataTableWrapper
            ref={dtRef}
            dtOptions={dtOptions}
        />
    );
}